import IPC from '../../../helpers/ipc';
import { POPUP_ACTIONS } from '../../../components/layers/popup/types';
import store from '../../../helpers/store';

const FormatText = {
    name: 'formatText',
    exec: customMessage => {
        if (customMessage.payload.options.format === 'formLink') {
            customMessage.message.replace(
                customMessage.payload.options.textToFormat,
                `[${customMessage.payload.options.textToFormat}](form:${customMessage.payload.options.value})`
            );
        }

        const state = store.getState();
        IPC.sendEvent(POPUP_ACTIONS.LOAD_CONFIG, {
            defaultView: 'questionnairePopup',
            id: customMessage.payload.options.value,
            engagementID: state.config.widget.engagementID,
            questionnaireOptions: {
                questionnaireName: customMessage.payload.options.value
            }
        });
    }
};

export default FormatText;
